import { RTCBufferTypes } from '../constants/rtcBufferConstants';

const popInputBuffer = () => ({
    type: RTCBufferTypes.BUFFER_INPUT_POP
});

const pushInputBuffer = (message) => ({
    type: RTCBufferTypes.BUFFER_INPUT_PUSH,
    message
});

const popOutputBuffer = () => ({
    type: RTCBufferTypes.BUFFER_OUTPUT_POP
});

const pushOutputBuffer = (message) => ({
    type: RTCBufferTypes.BUFFER_OUTPUT_PUSH,
    message
});

export default {
    popInputBuffer,
    pushInputBuffer,
    popOutputBuffer,
    pushOutputBuffer
};